import { useState } from 'react'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface Props {
  answers: { [key: string]: string }
}

export const TemporaryDisabilitiesToggle = ({ answers }: Props) => {
  const alreadySelectedEmployeeIds = answers?.temporary_disabilities_managers?.toString() || ''
  const parsedIds: number[] = JSON.parse('[' + alreadySelectedEmployeeIds + ']')
  const initialIds = parsedIds.filter((id) => id)
  const enabled = answers.its_enabled?.toString() || 'false'
  const itsEnabled = JSON.parse(enabled) === true

  const [employeeSelection, setEmployeeSelection] = useState<EmployeeSelectorV2MultiSelectState>({
    type: 'manual',
    ids: initialIds,
  })

  const toggleIts = () => {
    answers['its_enabled'] = !itsEnabled ? 'true' : 'false'
  }

  // For backward compatibility with the backend, we compute the IDs as comma-separated string
  const selectedEmployeeIds =
    employeeSelection.type === 'manual' ? employeeSelection.ids.join(',') : ''

  useEffect(() => {
    answers['temporary_disabilities_managers'] = selectedEmployeeIds
  }, [selectedEmployeeIds])

  return (
    <Box width="s400" padding="s16">
      <Card>
        <Card.Title size="small">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.title'
          )}
        </Card.Title>
        <Card.Description>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.description'
          )}
        </Card.Description>

        <Card.ExpandableContent expanded={itsEnabled} onExpandChange={toggleIts}>
          <Box flexDirection="row" justifyContent="flexStart" alignItems="center" gap="s4">
            <Text.Normal weight="semibold">
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.admins'
              )}
            </Text.Normal>

            <InformationTooltip
              information={i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.absences.temporary_disabilities.tooltip'
              )}
              icon="info-circle"
              color="grey700"
            />
          </Box>
          <EmployeeSelectorV2
            multiple
            value={initialIds}
            onChange={setEmployeeSelection}
            options={{ hideSearchIcon: true }}
          />
        </Card.ExpandableContent>
      </Card>
    </Box>
  )
}
